// MFA Types

// MFA Enrollment Step enum
export enum MFAEnrollmentStep {
  INTRO = 'intro',
  QR = 'qr',
  VERIFY = 'verify',
  BACKUP = 'backup',
}

// MFA Error Codes enum
export enum MFAErrorCode {
  MFA_REQUIRED = 'MFA_REQUIRED',
  MFA_ENROLLMENT_REQUIRED = 'MFA_ENROLLMENT_REQUIRED',
  INVALID_MFA_CODE = 'INVALID_MFA_CODE',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
}

export interface MFAEnrollResponse {
  factor_id: string;
  totp_qr_code: string;
  totp_secret: string;
  totp_uri: string;
}

export interface MFAVerifyEnrollmentParams {
  factor_id: string;
  code: string;
}

export interface MFAVerifyEnrollmentResponse {
  backup_codes: string[];
}

export interface MFARegenerateBackupCodesResponse {
  backup_codes: string[];
}

export interface MFAStatusResponse {
  enrolled: boolean;
  backup_codes_remaining: number;
  backup_codes_acknowledged: boolean;
}

export interface MFALoginChallenge {
  code: MFAErrorCode.MFA_REQUIRED;
  message: string;
  mfa_challenge_id: string;
}

export interface MFAEnrollmentRequired {
  code: MFAErrorCode.MFA_ENROLLMENT_REQUIRED;
  message: string;
  enrollment_token: string;
}

export interface MFALoginParams {
  email: string;
  password: string;
  remember_me: boolean;
  mfa_code?: string;
  mfa_challenge_id?: string;
}
